import {
  faArrowLeft,
  faCamera,
  faCircleCheck,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  createMatchingRequest,
  editMatch,
  editMatchAll,
  getMatchingCategory,
  getMatchingSubCategory,
  getMatchingSubDetailCategory,
} from "firebase_/firebase_function/matching";
import { useEffect, useMemo, useRef, useState } from "react";
import ReactModal from "react-modal";
import { emptyCheck } from "util/function/function";
import CircleCheckIcon from "assets/dialog_assets/circleCheck.svg";
import { useUser } from "util/context/user_context";
import OnlyLoadingScreen from "components/loading_screen";
import { useParams } from "react-router-dom";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import OnlyLoadingPage from "components/loading_page";

export default function SelectCategoryDesktop({ open, onClose, onSubmit, data, isEdit }) {
  const [categoryList, setCategoryList] = useState([]);
  const [status, setStatus] = useState(0);
  const [loading, setLoading] = useState(true);

  /// ✅ 확인 모달 관련
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  /// ✅ 선택한 카테고리
  const [selectCategory, setSelectCategory] = useState("");

  useEffect(() => {
    if (open) {
      setSelectCategory("");
      fetchData();
    }
  }, [open])

  /// ✅ 분야 (대분류) 데이터 가져오기
  const fetchData = async () => {
    setLoading(true);

    const response = await getMatchingCategory();

    if (response) {
      setCategoryList(response);
    };

    setLoading(false);
  }

  return (
    <>
      <ReactModal
        isOpen={open}
        onRequestClose={() => onClose()}
        shouldCloseOnOverlayClick={false}
        style={{
          overlay: {
            zIndex: 100,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            fontFamily: "InterVariable",
            zIndex: "150",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            borderRadius: "16px",
            backgroundColor: "white",
            overflow: "auto",
            width: "800px",
            height: "fit-content",
            padding: "0px",
            userSelect: "none",
          },
        }}
      >
        {(loading || !categoryList.length > 0) ? (
          <div style={{ height: "500px", display: "flex", flexDirection: "column" }}>
            <OnlyLoadingPage />
          </div>
        ) : (
          <>
            <div
              style={{
                borderBottom: "1px solid #E5E7EB",
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                padding: "8px 0px"
              }}
            >
              <button
                type="button"
                onClick={() => onClose()}
                style={{ padding: "0px 18px" }}
              >
                <FontAwesomeIcon icon={faXmark} size="xl" color="#6B7280" />
              </button>
            </div>

            <div
              style={{
                padding: "18px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                minHeight: "156px",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              <div className="f18_1F2937_W500">
                분야 선택
              </div>
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                  }}
                >
                  {categoryList.map((category, index) => (
                    <button
                      className={`hover:bg-black/5 transition-all active:bg-black/10 f16_1F2937_W500`}
                      key={index}
                      style={{
                        height: "84px",
                        width: "100%",
                        maxWidth: "240px",
                        border: "2px solid #E5E7EB",
                        borderRadius: "12px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: category.name === selectCategory ? "#98B88A" : "",
                      }}
                      onClick={() => {
                        setSelectCategory(category.name);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                          padding: "16px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {status < 1 && (
                          <img
                            src={`/${category.icon}`}
                            alt={category.name}
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "12px",
                              objectFit: "cover",
                            }}
                            draggable="false"
                          />
                        )}
                        <div className="f16_1F2937_W500">{category.name}</div>
                      </div>
                    </button>
                  ))}
                  {/* 전체선택 */}
                  <button
                    className={`hover:bg-black/5 transition-all active:bg-black/10 f16_1F2937_W500`}
                    style={{
                      height: "84px",
                      width: "100%",
                      maxWidth: "240px",
                      border: "2px solid #E5E7EB",
                      borderRadius: "12px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "전체선택" === selectCategory ? "#98B88A" : "",
                    }}
                    onClick={() => {
                      setSelectCategory("전체선택");
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        padding: "16px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {status < 1 && (
                        <img
                          src={`/assets/category/all_select_icon.svg`}
                          style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "12px",
                            objectFit: "cover",
                          }}
                          draggable="false"
                        />
                      )}
                      <div className="f16_1F2937_W500">{"전체선택"}</div>
                    </div>
                  </button>
                </div>
              </>
            </div>
            <div className="flex w-full p-4 gap-4">
              <>
                <button
                  style={{
                    background: "#2E4A24",
                    height: "48px",
                    borderRadius: "12px",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "500",
                    width: "100%",
                  }}
                  onClick={() => {
                    if (selectCategory == "") {
                      setOnlyConfirmModal(true);
                      setModalMessage("분야를 선택해주세요.");
                      return;
                    }

                    onSubmit(selectCategory);
                    onClose();
                  }}
                >
                  선택 완료
                </button>
              </>
            </div>
          </>
        )}
      </ReactModal >
      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => setOnlyConfirmModal(false)}
        message={modalMessage}
      />
    </>
  );
};
